<template>
  <div>
    <section-title class="mt-3" content="Tópico" :has-line="true" />
    <div class="rounded pt-2 pb-3">
      <div class="row">
        <div class="col">
          <p class="font-14 font-weight-normal">
            Seleccione el tópico que determinará los datos representados en cada
            fila de su reporte:
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <radio-button-big-square
              v-if="!readOnly"
              :options="topicOptions"
              v-model="model.topic"
              custom-error-msg="Debe seleccionar al menos un tópico."
              :error="errors[0]"
              :handle-topic-change="handleTopicChange"
              :is-mobile="isMobile"
            />
            <radio-button-big-square
              v-else
              :options="topicOptions"
              v-model="model.topic.id"
              :disabled="readOnly"
              :handle-topic-change="handleTopicChange"
              :is-mobile="isMobile"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { mapState } from 'vuex'
import { name as userModuleName } from '@/modules/user/store'
import SectionTitle from 'SectionTitle'
import { RadioButtonBigSquare } from '@/components/common'
import SpecialService from '@/services/api/special.api'

export default {
  name: 'Topic',
  components: {
    RadioButtonBigSquare,
    SectionTitle,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      topics: [],
      oldTopic: 0,
      event: null,
    }
  },
  computed: {
    ...mapState(userModuleName, ['navCategories']),
    topicOptions() {
      const items = this.topics.map((e) => ({
        name: e.name,
        value: +e.id,
        icon: e.icon,
      }))

      return items
    },
    model: {
      get() {
        return this.value || {}
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  mounted() {
    this.getTopics()
  },
  methods: {
    async getTopics() {
      const { data } = await SpecialService.getTopics()
      this.value.listOfTopics = data
      this.topics = data
    },
    async handleTopicChange(newValue) {
      if (newValue && this.value.columns && this.value.columns.length > 0) {
        const result = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar de tópico? Se borrarán los datos previamente seleccionados.`,
          'Sí',
          'No'
        )
        return result
      }

      return true
    },
  },
}
</script>
